import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../entities/error.entity";
import QAAgentEntity from "../entities/qa_agent.entity";
import QAQuestionEntity from "../entities/qa_question.entity";
import SearchResultEntity from "../entities/search_result.entity";
import QACategoryEntity from "../entities/qa_category.entity";
import MasterItemEntity from "../entities/master_item.entity";

export default interface QARepository {
    createAgent(data: FormData): Promise<Either<ErrorEntity, QAAgentEntity>>;
    searchAgents(_: { query: string | undefined, page: number, itemsPerPage: number, operationId?: string }): Promise<Either<ErrorEntity, SearchResultEntity<QAAgentEntity>>>;
    searchOpTypes(_: { query: string | undefined, page: number, itemsPerPage: number}): Promise<Either<ErrorEntity, SearchResultEntity<MasterItemEntity>>>;
    getAgentById(id: string): Promise<Either<ErrorEntity, QAAgentEntity>>;
    addQuestionToAgent(_: { category: QACategoryEntity, question: QAQuestionEntity }): Promise<Either<ErrorEntity, QAQuestionEntity>>;
    deleteQuestionFromAgent(questionId: string): Promise<Either<ErrorEntity, void>>;
    updateQuestionFromAgent(question: QAQuestionEntity): Promise<Either<ErrorEntity, QAQuestionEntity>>;
    deleteAgent(id: string): Promise<Either<ErrorEntity, void>>;
    updateAgent(agent: FormData): Promise<Either<ErrorEntity, QAAgentEntity>>;
    addCategory(qaCategory: QACategoryEntity): Promise<Either<ErrorEntity, QACategoryEntity>>;
    deleteCategory(id: string): Promise<Either<ErrorEntity, void>>;
    updateCategory(qaCategory: QACategoryEntity): Promise<Either<ErrorEntity, QACategoryEntity>>;
}

export const QARepositoryName = "QARepository";